import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { CustomLoadingButton } from 'components/Buttons/CustomLoadingButton/CustomLoadingButton';
import { useState, type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

type ModalType = 'SAVE' | 'GENERATE' | null;

export const SaveConfirmationModal = ({
  modalOpen,
  setModalOpen,
  currentCustomer,
  handleGenerate,
}: {
  modalOpen: {
    type: ModalType;
  };
  setModalOpen: Dispatch<
    SetStateAction<{
      type: ModalType;
    }>
  >;
  currentCustomer: string;
  handleGenerate: () => Promise<void>;
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const handleConfirm = async () => {
    try {
      setLoading(true);
      await handleGenerate();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Dialog
      open={modalOpen.type === 'GENERATE'}
      onClose={(event, reason) => {
        if (reason && reason === 'backdropClick') {
          return;
        }
        setModalOpen({ type: null });
      }}
      disableEscapeKeyDown
    >
      <DialogTitle>{t('update_configuration')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('this_will_update_navigation_configuration_for')}{' '}
          <strong>{currentCustomer}</strong>{' '}
          {t('based_on_your_current_selection_are_you_sure_you_want_to_pro')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <CustomLoadingButton
          onClick={() => {
            setModalOpen({ type: null });
          }}
          disabled={loading}
          loading={loading}
          sx={{
            width: '100px',
            height: '36px',
          }}
          color="error"
        >
          {t('cancel')}
        </CustomLoadingButton>

        <CustomLoadingButton
          disabled={loading}
          onClick={handleConfirm}
          loading={loading}
          color="success"
          sx={{
            width: '120px',
            height: '36px',
          }}
        >
          {t('yes_save')}
        </CustomLoadingButton>
      </DialogActions>
    </Dialog>
  );
};
